var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-status",class:'order-status-' + _vm.orderStatus.replaceAll(' ', '-').toLowerCase()},[_vm._v("\n  "+_vm._s(_vm.orderStatus)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }